import { render, staticRenderFns } from "./SamIcon.vue?vue&type=template&id=57fb8eb2&scoped=true&shadow"
import script from "./SamIcon.vue?vue&type=script&lang=js&shadow"
export * from "./SamIcon.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamIcon.vue?vue&type=style&index=0&id=57fb8eb2&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "57fb8eb2",
  null
  ,true
)

export default component.exports